import { colors } from "../tokens";

export interface BuildInfoProps {
  /** Short commit hash, or "unknown" — always "unknown" in a real Docker
   * build (.git is excluded from the build context), only meaningful for
   * a local dev/build run outside Docker. Pass each app's own
   * __BUILD_SHA__ (injected via that app's vite.config.ts). */
  sha: string;
  /** ISO build timestamp — the reliable "did my deploy actually pick up
   * the latest code" signal, works in every build context. Pass each
   * app's own __BUILD_TIME__. */
  time: string;
  /** Defaults to colors.textFaint (for a light background) — override on a
   * dark surface (e.g. a navy sidebar) so it's still legible. */
  color?: string;
}

/** Small, easy-to-miss-on-purpose version footer — not a feature, just
 * something to check when a deploy's landing is in doubt. */
export function BuildInfo({ sha, time, color = colors.textFaint }: BuildInfoProps) {
  const date = new Date(time);
  const label = Number.isNaN(date.getTime())
    ? time
    : date.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  return (
    <div style={{ fontSize: 11, color, fontWeight: 600, textAlign: "center" }}>
      Build {sha} · {label}
    </div>
  );
}
